import { MediaMatcher } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, OnDestroy, HostListener } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@app/components/authentication/services/auth.service';

import { AppConstant } from '@app/app.constants';

/* Rxjs */
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnDestroy {
  @Input() sidenavOpened = false;

  @Output() sidenavToggle = new EventEmitter(false);

  pageTitle = null;

  mobileQuery: MediaQueryList = this.mediaMatch.matchMedia(this.appConstant?.mobileResolution);

  @HostListener('window:resize')
  onResize() {
    this.mobileQuery = this.mediaMatch.matchMedia(this.appConstant?.mobileResolution);
  }

  constructor(private router: Router, private activeRoute: ActivatedRoute, public authService: AuthService, private mediaMatch: MediaMatcher, private appConstant: AppConstant) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      if (this.activeRoute.snapshot.firstChild?.data['title']) {
        this.pageTitle = this.activeRoute.snapshot.firstChild?.data['title'];
      }
    });
  }
  ngOnDestroy(): void {
    this.pageTitle = null;
  }

  onToggleSidenav = () => {
    this.sidenavOpened = !this.sidenavOpened;
    this.sidenavToggle.emit(this.sidenavOpened);
  };
}
